function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M390.061 222.603h-56.147c0-10.244-8.306-18.551-18.551-18.551l-14.84 29.682s15.831 44.522 15.336 44.522h18.551c10.246 0 18.551-8.306 18.551-18.551 10.246 0 18.551-8.306 18.551-18.551h-.618c10.242 0 19.167-8.305 19.167-18.551zm-268.122 0h56.147c0-10.244 8.306-18.551 18.551-18.551l14.84 29.682s-15.831 44.522-15.336 44.522H177.59c-10.246 0-18.551-8.306-18.551-18.551-10.246 0-18.551-8.306-18.551-18.551h.618c-10.242 0-19.167-8.305-19.167-18.551z",
  fill: "#acabb1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M315.362 322.777v7.421H196.638v-7.421h-29.681v29.682h29.681v7.419h118.724v-7.419h29.681v-29.682z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M196.638 204.052v74.202c0 45.44 59.362 59.363 59.362 59.363s59.362-13.923 59.362-59.363v-74.202L256 196.632l-59.362 7.42z",
  fill: "#0052b4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M196.641 233.734h118.728v44.522H196.641z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M285.682 166.951v11.13l-7.421 3.71-7.421-7.419v-22.261h-29.68v22.261l-7.421 7.419-7.421-3.71v-11.13h-29.68v37.101h118.724v-37.101z"
});

const SvgStBarts = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStBarts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/st-barts.ab4dbf55.svg";
export { ForwardRef as ReactComponent };